import { useLocation } from 'react-router-dom';
import { usePageSeo } from '../hooks/usePageSeo';

export const PageSeo = () => {
  const { pathname, hash } = useLocation();
  usePageSeo(pathname, hash);
  return null;
};